export default __webpack_public_path__ + "static/project-slide-8-768-700-8f735c885ac686c70db0a284a900d6ad.jpg";